import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../Utility/Modal/Modal';
import styles from './LockedFeatureDialogue.module.scss';
import { Box, Button, Icon } from '../../../..';
import { getCSSVariable } from '../../../utils';

export interface LockedFeatureDialogueProps {
  isVisible: boolean;
  lockedFeature?: string;
  description?: string;
  cancel: () => void;
  contactOutTeam: () => void;
}

type FC = FunctionComponent<LockedFeatureDialogueProps>;

const LockedFeatureDialogue: FC = ({ isVisible, lockedFeature = 'this feature', cancel, contactOutTeam }) => {
  const { t } = useTranslation('components', { keyPrefix: 'LockedFeatureDialogue' });
  const zIndex = getCSSVariable('--zLockedFeatureDialog');

  return (
    <Modal isVisible={isVisible} enableBgClick={false} zIndex={Number(zIndex)}>
      <div className={styles.container}>
        <Box flx="col" ai="center">
          <Icon icon="iOutlined" size="xxlg" color="purple" bgColor="primary-light" />
          <div className={styles.TitleContainer}>
            <h1>{t('title', { defaultValue: 'Upgrade Your Plan!' })}</h1>
          </div>

          <div className={styles.DescriptionContainer}>
            <p>{t('description', { lockedFeature, defaultValue: `You do not have access to ${lockedFeature} as it is not part of your current plan.` })}</p>
            <p>{t('getInTouch', { defaultValue: 'Get in touch with us to upgrade your plan!' })}</p>
          </div>
          <div className={styles.ButtonBar}>
            <Button id="AddLabel-Accept" label={t('maybeLater', { defaultValue: 'Maybe Later' })} color="secondary" type="button" onClick={() => cancel()} />
            <Button
              id="AddLabel-Accept"
              label={t('contactOurTeam', { defaultValue: 'Contact Our Team' })}
              color="primary"
              type="button"
              onClick={() => contactOutTeam()}
            />
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default LockedFeatureDialogue;
